__turbopack_context__.v({
  "control": "cEpH7G_control",
  "controls": "cEpH7G_controls",
  "indicator": "cEpH7G_indicator",
  "indicators": "cEpH7G_indicators",
  "viewport": "cEpH7G_viewport",
});
